/**
 * The three attribution values a landing can carry, as they are stored.
 * `vtmSrc` and `label` are empty strings when the landing carried neither,
 * which attributes later bookings to direct traffic.
 */
export interface Attribution {
  vtmSrc: string
  label: string
  vclid: string
}

/** Version of the event contract, so the pipeline can tell payloads apart. */
export const ATTRIBUTION_EVENT_VERSION = 'v1'

/**
 * Payload of the `System_Attribution_Changed` event. Field names follow
 * `vio/attribution-tracking`, which the mobile app implements against too.
 */
export interface AttributionChangedPayload {
  landingURL: string
  vclid: string
  label: string
  vtm_src: string
  brand: string
  anonymousID: string
  version: string
}
